import React from 'react';

interface IconView4x4Props {
    active: boolean; // Принимаем проп для указания активного состояния
}

const IconView4x4: React.FC<IconView4x4Props> = ({ active }) => (

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M3.33268 0.666504H0.666016V3.33317H3.33268V0.666504ZM3.33268 4.6665H0.666016V7.33317H3.33268V4.6665ZM0.666016 8.6665H3.33268V11.3332H0.666016V8.6665ZM3.33268 12.6665H0.666016V15.3332H3.33268V12.6665ZM4.66602 0.666504H7.33268V3.33317H4.66602V0.666504ZM7.33268 4.6665H4.66602V7.33317H7.33268V4.6665ZM4.66602 8.6665H7.33268V11.3332H4.66602V8.6665ZM7.33268 12.6665H4.66602V15.3332H7.33268V12.6665ZM8.66602 0.666504H11.3327V3.33317H8.66602V0.666504ZM15.3327 0.666504H12.666V3.33317H15.3327V0.666504ZM8.66602 4.6665H11.3327V7.33317H8.66602V4.6665ZM15.3327 4.6665H12.666V7.33317H15.3327V4.6665ZM8.66602 8.6665H11.3327V11.3332H8.66602V8.6665ZM15.3327 8.6665H12.666V11.3332H15.3327V8.6665ZM8.66602 12.6665H11.3327V15.3332H8.66602V12.6665ZM15.3327 12.6665H12.666V15.3332H15.3327V12.6665Z"
            fill={active ? '#FFFFFF' : '#4D4E65'} />
    </svg>

);

export default IconView4x4;

